import React, { useState } from "react";

import { getAccessToken } from 'utils/authentication';
import { useMutation } from "react-query";
import { cancelOffer } from "services/payments";

import ActionButton from "@core/components/actionbutton/ActionButton";

import TickIcon from 'assets/icons/square-tick.svg';

import classes from './CancelDiscountModal.module.scss';



const CancelDiscountModal = ({ continueCancelHandler, data, toast, closeOfferModalHandler }) => {
    const [isDelay, setIsDelay] = useState(false);
    const { mutate, isLoading } = useMutation(['accept-cancelation-offer', getAccessToken()], () => cancelOffer.POST(), {
        onSuccess: (data) => {
            setIsDelay(true);
            setTimeout(() => {
                toast(

                    data?.data?.message,
                    'success'
                );
                closeOfferModalHandler();
                setIsDelay(false);
            }, 2000);

        },
        onError: (err) => {
            toast(getErrorText(err), 'Alert');
            closeOfferModalHandler();
        }
    });
    return (
        <div className={classes.wrapper}>
            <h2>{data?.data?.offer_percentage}% Off</h2>
            <h4>We'd Hate to See You Go!</h4>
            <p>
                Your journey means a lot to us. We would like to offer you <b>{data?.data?.offer_percentage}% discount
                    for your next {data?.data?.offer_duration}</b> to explore Pharmuni in full. Have you checked these benefits?
            </p>
            <ul>
                <li>
                    <TickIcon /> 50+ pharma courses
                </li>
                <li>
                    <TickIcon /> ISO-9001 backed certificates
                </li>
                <li>
                    <TickIcon /> Free monthly career coaching with our expert
                </li>
                <li>
                    <TickIcon /> 5+ career paths
                </li>
                <li>
                    <TickIcon /> 1000+ pharma jobs
                </li>
            </ul>
            <div className={classes.actions}>
                <ActionButton loading={isLoading || isDelay} onClick={() => mutate()}>Yes, I'll Take {data?.data?.offer_percentage}% Off!</ActionButton>
                <ActionButton kind="blank" onClick={continueCancelHandler}>
                    No, cancel my subscription
                </ActionButton>
            </div>
        </div>
    );
}

export default CancelDiscountModal;